import axios from "../api/axios";

const delay = () => new Promise((res) => setTimeout(() => res(), 5000));

// AUTH SERVICES

// const DASHBOARD_LOGIN = '/auth/login';
// const PORTAL_LOGIN = '/auth/portal_login';
const CHECK_PF_NUMBER = "/auth/check_pf_number";

const ADMIN_LOGIN = "/auth/admin_login";
const MEMBER_LOGIN = "/auth/member_login";
const ADMIN_LOGOUT = "/auth/admin_logout";
const MEMBER_LOGOUT = "/auth/member_logout";
const CHECK_EMAIL = "/auth/check_email";
// const CHECK_PFNUMBER = '/auth/check_pf_number';
const SET_ADMIN_PASSWORD = "/auth/set_admin_password";
const SET_MEMBER_PASSWORD = "/auth/set_member_password";
const RESET_ADMIN_ACCOUNT = "/auth/reset_admin_account";
const RESET_MEMBER_ACCOUNT = "/auth/reset_member_account";
const CLEAR_MEMBER_ACCOUNT = "/auth/clear_member_password";

const CHANGE_ADMIN_PASSWORD = "/auth/change_admin_password";
const CHANGE_MEMBER_PASSWORD = "/auth/change_member_password";

export async function adminLogin(data) {
  const response = await axios.post(ADMIN_LOGIN, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function memberLogin(data) {
  const response = await axios.post(MEMBER_LOGIN, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function adminLogout() {
  await axios.get(ADMIN_LOGOUT, {
    withCredentials: true,
  });
  return;
}
export async function memberLogout() {
  await axios.get(MEMBER_LOGOUT, {
    withCredentials: true,
  });
  return;
}

export async function checkAdminEmail(email) {
  const response = await axios.post(CHECK_EMAIL, { email: email });
  return response.data;
}

export async function setAdminPassword(data) {
  const response = await axios.post(SET_ADMIN_PASSWORD, data);
  return response.data;
}

export async function setMemberPassword(data) {
  const response = await axios.post(SET_MEMBER_PASSWORD, data);
  return response.data;
}

export async function resetAdminAccount(data) {
  const response = await axios.patch(
    `${RESET_ADMIN_ACCOUNT}/${data.id}`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function resetMemberAccount(data) {
  const response = await axios.patch(
    `${RESET_MEMBER_ACCOUNT}/${data.id}`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function clearMemberPassword(data) {
  const response = await axios.post(`${CLEAR_MEMBER_ACCOUNT}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function checkEmail(email) {
  const response = await axios.get(CHECK_EMAIL, { email: email });
  return response.data;
}
export async function checkPfNumber(pf_number) {
  const response = await axios.post(CHECK_PF_NUMBER, {
    pf_number: pf_number,
  });
  return response.data;
}

export async function changeAdminPassword(data) {
  const response = await axios.post(CHANGE_ADMIN_PASSWORD, data);
  return response.data;
}
export async function changeMemberPassword(data) {
  const response = await axios.post(CHANGE_MEMBER_PASSWORD, data);
  return response.data;
}
// REFRESH TOKEN
const ADMIN_REFRESH_TOKEN = "/token/admin_refresh_token";
const MEMBER_REFRESH_TOKEN = "/token/member_refresh_token";

export async function adminRefreshToken() {
  const response = await axios.get(ADMIN_REFRESH_TOKEN, {
    withCredentials: true,
  });
  return response.data;
}
export async function memberRefreshToken() {
  const response = await axios.get(MEMBER_REFRESH_TOKEN, {
    withCredentials: true,
  });
  return response.data;
}

// ADMIN USERS  API

const adminUsersUrlEndpoint = "/users";

export async function getAdminUsers() {
  await delay();
  const response = await axios.get(`${adminUsersUrlEndpoint}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function addAdminUser(data) {
  const response = await axios.post(`${adminUsersUrlEndpoint}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function updateAdminUser(data) {
  const response = await axios.patch(
    `${adminUsersUrlEndpoint}/${data.id}`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function getAdminUserById(id) {
  const response = await axios.get(`${adminUsersUrlEndpoint}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deleteAdminUser(id) {
  const response = await axios.delete(`${adminUsersUrlEndpoint}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });

  return response.data;
}

export async function checkAdminUsername(username) {
  const response = await axios.post(
    `${adminUsersUrlEndpoint}/check_admin_username`,
    { username: username },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function searchAdminUser(data) {
  const response = await axios.post(
    `${adminUsersUrlEndpoint}/search_admin_user`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function resetUserPassword(id) {
  const response = await axios.get(
    `${adminUsersUrlEndpoint}/reset_password/${id}`,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function onlineUsers() {
  await delay();
  const response = await axios.get(`${adminUsersUrlEndpoint}/online_users`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

// PORTAL USERS  API
const portalUsersUrlEndpoint = "/portal";

export async function getPortalUsers() {
  await delay();
  const response = await axios.get(`${portalUsersUrlEndpoint}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function addPortalUser(data) {
  const response = await axios.post(`${portalUsersUrlEndpoint}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function createPortalUser(data) {
  const response = await axios.post(
    `${portalUsersUrlEndpoint}/create_portal_user`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function updatePortalUser(data) {
  const response = await axios.patch(
    `${portalUsersUrlEndpoint}/${data.id}`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function getPortalUserById(id) {
  const response = await axios.get(`${portalUsersUrlEndpoint}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deletePortalUser(id) {
  const response = await axios.delete(`${portalUsersUrlEndpoint}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });

  return response.data;
}

export async function getPortalUserByEmail(email) {
  const response = await axios.post(
    `${portalUsersUrlEndpoint}/get_portal_user_by_email`,
    { email: email }
  );
  return response.data;
}

export async function searchPortalUser(data) {
  const response = await axios.post(
    `${portalUsersUrlEndpoint}/search_portal_user`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function verifyUserEmail(data) {
  const response = await axios.post(
    `${portalUsersUrlEndpoint}/verify_portal_user_email`,
    { pf_number_email: data },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function resetMemberPassword(code) {
  const response = await axios.post(
    `${portalUsersUrlEndpoint}/reset_member_password`,
    { secret_code: code },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function saveResetPassword(data) {
  const response = await axios.post(
    `${portalUsersUrlEndpoint}/save_reset_password/${data.id}`,
    data
  );
  return response.data;
}

// ROLES  API
const ROLES = "/roles/get_roles";
const GET_ROLE_BYID = "/roles/get_role";
const ADD_ROLE = "/roles/add_role";
const UPDATE_ROLE = "/roles/update_role";
const DELETE_ROLE = "/roles/delete_role";

export async function getRoles() {
  const response = await axios.get(ROLES, {
    withCredentials: true,
  });
  return response.data;
}

export async function addRole(data) {
  const response = await axios.post(ADD_ROLE, data, {
    withCredentials: true,
  });
  return response.data;
}

export async function updateRole(data) {
  const response = await axios.patch(`${UPDATE_ROLE}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getRoleById(id) {
  const response = await axios.get(`${GET_ROLE_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deleteRole(id) {
  const response = await axios.delete(`${DELETE_ROLE}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
// PERMISSIONS  API
const PERMISSIONS = "/permissions/get_permissions";
const GET_PERMISSION_BYID = "/permissions/get_permission";
const ADD_PERMISSION = "/permissions/add_permission";
const UPDATE_PERMISSION = "/permissions/update_permission";
const DELETE_PERMISSION = "/permissions/delete_permission";

export async function getPermissions() {
  const response = await axios.get(PERMISSIONS, {
    withCredentials: true,
  });
  return response.data;
}

export async function addPermission(data) {
  const response = await axios.post(ADD_PERMISSION, data, {
    withCredentials: true,
  });
  return response.data;
}

export async function updatePermission(data) {
  const response = await axios.patch(`${UPDATE_PERMISSION}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getPermissionById(id) {
  const response = await axios.get(`${GET_PERMISSION_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deletePermission(id) {
  const response = await axios.delete(`${DELETE_PERMISSION}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

// CITIZENSHIP API
const CITIZENSHIP = "/citizenship/get_citizenship";
const GET_CITIZENSHIP_BYID = "/citizenship/get_citizenship";
const ADD_CITIZENSHIP = "/citizenship/add_citizenship";
const UPDATE_CITIZENSHIP = "/citizenship/update_citizenship";
const DELETE_CITIZENSHIP = "/citizenship/delete_citizenship";

export async function getCitizenship() {
  const response = await axios.get(CITIZENSHIP, {
    withCredentials: true,
  });
  return response.data;
}

export async function addCitizenship(data) {
  const response = await axios.post(ADD_CITIZENSHIP, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function updateCitizenship(data) {
  const response = await axios.patch(`${UPDATE_CITIZENSHIP}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getCitizenshipById(id) {
  const response = await axios.get(`${GET_CITIZENSHIP_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function deleteCitizenship(id) {
  const response = await axios.delete(`${DELETE_CITIZENSHIP}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
// HOLIDAYS API
const HOLIDAYS = "/holidays/get_holidays";
const GET_HOLIDAY_BYID = "/holidays/get_holiday";
const ADD_HOLIDAY = "/holidays/add_holiday";
const UPDATE_HOLIDAY = "/holidays/update_holiday";
const DELETE_HOLIDAY = "/holidays/delete_holiday";

export async function getHolidays() {
  const response = await axios.get(HOLIDAYS, {
    withCredentials: true,
  });
  return response.data;
}

export async function addHoliday(data) {
  const response = await axios.post(ADD_HOLIDAY, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function updateHoliday(data) {
  const response = await axios.patch(`${UPDATE_HOLIDAY}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getHolidayById(id) {
  const response = await axios.get(`${GET_HOLIDAY_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function deleteHoliday(id) {
  const response = await axios.delete(`${DELETE_HOLIDAY}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
// BROKERS API
const BROKERS = "/brokers/get_brokers";
const GET_BROKER_BYID = "/brokers/get_broker";
const ADD_BROKER = "/brokers/add_broker";
const UPDATE_BROKER = "/brokers/update_broker";
const DELETE_BROKER = "/brokers/delete_broker";

export async function getBrokers() {
  const response = await axios.get(BROKERS, {
    withCredentials: true,
  });
  return response.data;
}

export async function addBroker(data) {
  const response = await axios.post(ADD_BROKER, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function updateBroker(data) {
  const response = await axios.patch(`${UPDATE_BROKER}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getBrokerById(id) {
  const response = await axios.get(`${GET_BROKER_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function deleteBroker(id) {
  const response = await axios.delete(`${DELETE_BROKER}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

// STATUS API
const STATUS = "/status/get_status";
const GET_STATUS_BYID = "/status/get_status";
const ADD_STATUS = "/status/add_status";
const UPDATE_STATUS = "/status/update_status";
const DELETE_STATUS = "/status/delete_status";

export async function getStatus() {
  const response = await axios.get(STATUS, {
    withCredentials: true,
  });
  return response.data;
}

export async function addStatus(data) {
  const response = await axios.post(ADD_STATUS, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function updateStatus(data) {
  const response = await axios.patch(`${UPDATE_STATUS}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getStatusById(id) {
  const response = await axios.get(`${GET_STATUS_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function deleteStatus(id) {
  const response = await axios.delete(`${DELETE_STATUS}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
// INVESTMENT CATEGORIES API
const INVESTMENT_CATEGORIES = "/investment_category/get_investment_categories";
const GET_INVESTMENT_CATEGORY_BYID =
  "/investment_category/get_investment_category";
const ADD_INVESTMENT_CATEGORY = "/investment_category/add_investment_category";
const UPDATE_INVESTMENT_CATEGORY =
  "/investment_category/update_investment_category";
const DELETE_INVESTMENT_CATEGORY =
  "/investment_category/delete_investment_category";

export async function getInvestmentCategories() {
  const response = await axios.get(INVESTMENT_CATEGORIES, {
    withCredentials: true,
  });
  return response.data;
}

export async function addInvestmentCategories(data) {
  const response = await axios.post(ADD_INVESTMENT_CATEGORY, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function updateInvestmentCategories(data) {
  const response = await axios.patch(
    `${UPDATE_INVESTMENT_CATEGORY}/${data.id}`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function getInvestmentCategoriesById(id) {
  const response = await axios.get(`${GET_INVESTMENT_CATEGORY_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function deleteInvestmentCategories(id) {
  const response = await axios.delete(`${DELETE_INVESTMENT_CATEGORY}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

// TITLE API

const TITLES = "/titles/get_titles";
const GET_TITLE = "/titles/get_title";
const ADD_TITLE = "/titles/add_title";
const UPDATE_TITLE = "/titles/update_title";
const DELETE_TITLE = "/titles/delete_record";

export async function getTitles() {
  const response = await axios.get(TITLES);
  return response.data;
}

export async function getTitleById(id) {
  const response = await axios.get(GET_TITLE + `/${id}`);
  return response.data;
}

export async function addTitle(data) {
  const response = await axios.post(ADD_TITLE, data);
  return response.data;
}

export async function updateTitle(data) {
  const response = await axios.post(UPDATE_TITLE + `/${data.id}`, data);
  return response.data;
}

export async function deleteTitle(id) {
  const response = await axios.post(DELETE_TITLE, { id: id });
  return response.data;
}

// FILE UPLOADS

const UPLOAD_MEMBERS = "/file_uploads/upload_members";
const UPLOAD_ADDITIONAL_MEMBERS = "/file_uploads/upload_additional_members";
const UPLOAD_REGIONS = "/file_uploads/upload_regions";
const UPLOAD_CONSTITUENCIES = "/file_uploads/upload_constituencies";
const UPLOAD_BRANCHES = "/uploads/upload_branches";
// const ACCOUNTS = "/file_uploads/upload_accounts"
// const UPLOAD_CARDS = "/file_uploads/upload_cards"
// const EMAILS = "/file_uploads/upload_emails"
const UPLOAD_TITLES = "/file_uploads/upload_titles";
const UPLOAD_EMAILS = "/file_uploads/upload_emails";
const UPLOAD_BANKS = "/file_uploads/upload_banks";
const UPLOAD_BANK_BRANCHES = "/file_uploads/upload_bank_branches";
const POLLING_AGENTS = "/file_uploads/polling_agents";
const PROFILE_PICTURES = "/file_uploads/profile_pictures";

export async function uploadPollingAgents(data) {
  const response = await axios.post(POLLING_AGENTS, data, {
    withCredentials: true,
  });
  return response.data;
}
export async function uploadMembers(data) {
  const response = await axios.post(UPLOAD_MEMBERS, data, {
    withCredentials: true,
  });
  return response.data;
}
export async function uploadAdditionalMembers(data) {
  const response = await axios.post(UPLOAD_ADDITIONAL_MEMBERS, data, {
    withCredentials: true,
  });
  return response.data;
}
export async function uploadRegions(data) {
  const response = await axios.post(UPLOAD_REGIONS, data, {
    withCredentials: true,
  });
  return response.data;
}
export async function uploadConstituencies(data) {
  const response = await axios.post(UPLOAD_CONSTITUENCIES, data, {
    withCredentials: true,
  });
  return response.data;
}
export async function uploadBranches(data) {
  const response = await axios.post(UPLOAD_BRANCHES, data, {
    withCredentials: true,
  });
  return response.data;
}
export async function uploadTitles(data) {
  const response = await axios.post(UPLOAD_TITLES, data, {
    withCredentials: true,
  });
  return response.data;
}
export async function uploadBanks(data) {
  const response = await axios.post(UPLOAD_BANKS, data, {
    withCredentials: true,
  });
  return response.data;
}
export async function uploadBankBranches(data) {
  const response = await axios.post(UPLOAD_BANK_BRANCHES, data, {
    withCredentials: true,
  });
  return response.data;
}
export async function uploadEmails(data) {
  const response = await axios.post(UPLOAD_EMAILS, data, {
    withCredentials: true,
  });
  return response.data;
}

// CATEGORY  API
const CATEGORIES = "/categories/get_categories";
const GET_CATEGORY_BYID = "/categories/get_category";
const ADD_CATEGORY = "/categories/add_category";
const UPDATE_CATEGORY = "/categories/update_category";
const DELETE_CATEGORY = "/categories/delete_category";

export async function getCategories() {
  const response = await axios.get(CATEGORIES, {
    withCredentials: true,
  });
  return response.data;
}

export async function addCategory(data) {
  const response = await axios.post(ADD_CATEGORY, data, {
    withCredentials: true,
  });
  return response.data;
}

export async function updateCategory(data) {
  const response = await axios.patch(`${UPDATE_CATEGORY}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getCategoryById(id) {
  const response = await axios.get(`${GET_CATEGORY_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deleteCategory(id) {
  const response = await axios.delete(`${DELETE_CATEGORY}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

// PRODUCTS  API
const PRODUCTS = "/products/get_products";
const GET_PRODUCT_BYID = "/products/get_product";
const ADD_PRODUCT = "/products/add_product";
const UPDATE_PRODUCT = "/products/update_product";
const DELETE_PRODUCT = "/products/delete_product";

export async function getProducts() {
  const response = await axios.get(PRODUCTS, {
    withCredentials: true,
  });
  return response.data;
}

export async function addProduct(data) {
  const response = await axios.post(ADD_PRODUCT, data, {
    withCredentials: true,
  });
  return response.data;
}

export async function updateProduct(data) {
  const response = await axios.patch(`${UPDATE_PRODUCT}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getProductById(id) {
  const response = await axios.get(`${GET_PRODUCT_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deleteProduct(id) {
  const response = await axios.delete(`${DELETE_PRODUCT}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

// SUPPLIERS  API
const SUPPLIERS = "/suppliers/get_suppliers";
const GET_SUPPLIER_BYID = "/suppliers/get_supplier";
const ADD_SUPPLIER = "/suppliers/add_supplier";
const UPDATE_SUPPLIER = "/suppliers/update_supplier";
const DELETE_SUPPLIER = "/suppliers/delete_supplier";

export async function getSuppliers() {
  const response = await axios.get(SUPPLIERS, {
    withCredentials: true,
  });
  return response.data;
}

export async function addSupplier(data) {
  const response = await axios.post(ADD_SUPPLIER, data, {
    withCredentials: true,
  });
  return response.data;
}

export async function updateSupplier(data) {
  const response = await axios.patch(`${UPDATE_SUPPLIER}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getSupplierById(id) {
  const response = await axios.get(`${GET_SUPPLIER_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deleteSupplier(id) {
  const response = await axios.delete(`${DELETE_SUPPLIER}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

// MEMBERS API
const membersUrlEndpoint = "/members";

const SEARCH_REGION = "/members/search_by_region";
const PENDING_REGIONAL_APPROVALS = "/members/pending_regional_approvals";

const GET_APPROVE_MEMBER = "/members/get_approve_member";
const FIND_PFNUMBER = "/members/find_member_by_pf_number";
const FIND_MOBILE_NUMBER = "/members/find_member_by_mobile_number";
const FIND_BY_EMAIL = "/members/find_member_by_email";

const REGIONAL_MEMBERS = "/members/regional_members";
const ACTIVE_REGIONAL_MEMBERS = "/members/active_regional_members";
const INACTIVE_REGIONAL_MEMBERS = "/members/inactive_regional_members";
const DUPLICATE_RECORDS = "/members/duplicate_records";

export async function getMembers() {
  await delay();
  const response = await axios.get(`${membersUrlEndpoint}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function duplicateRecords() {
  await delay();
  const response = await axios.post(DUPLICATE_RECORDS, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export const getPaginatedMembers = async (page) => {
  const membersPerPage = 20;
  await delay();
  const response = await axios.post(
    `${membersUrlEndpoint}/paginated_members?page=${page}&limit=${membersPerPage}`,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
};

export async function getMemberById(id) {
  await delay();
  const response = await axios.get(`${membersUrlEndpoint}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function createMember(data) {
  const response = await axios.post(`${membersUrlEndpoint}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function updateMember(data) {
  const response = await axios.patch(`${membersUrlEndpoint}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deleteMember(id) {
  return await axios.delete(`${membersUrlEndpoint}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
}

export async function getActiveMembers() {
  await delay();
  const response = await axios.post(`${membersUrlEndpoint}/active_members`);
  return response.data;
}

export async function getInactiveMembers() {
  await delay();
  const response = await axios.post(`${membersUrlEndpoint}/inactive_members`);
  return response.data;
}

export async function searchMember(data) {
  const response = await axios.post(
    `${membersUrlEndpoint}/search_member`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function searchNewApplicant(data) {
  console.log(data);
  const response = await axios.post(
    `${membersUrlEndpoint}/search_new_applicant`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function searchExistingMember(data) {
  const response = await axios.post(
    `${membersUrlEndpoint}/search_existing_member`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function searchPortalMember(data) {
  const response = await axios.post(
    `${membersUrlEndpoint}/search_portal_member`,
    data
  );
  return response.data;
}
export async function searchRegionalMember(data) {
  const response = await axios.post(
    `${membersUrlEndpoint}/search_regional_member`,
    data
  );
  return response.data;
}
export async function searchMemberPayment(data) {
  const response = await axios.post(
    `${membersUrlEndpoint}/search_member_payment`,
    data
  );
  return response.data;
}
export async function searchMemberAccount(data) {
  const response = await axios.post(
    `${membersUrlEndpoint}/search_account`,
    data
  );
  return response.data;
}

export async function pendingRegionalApprovals(code) {
  const response = await axios.post(
    `${membersUrlEndpoint}/pending_regional_approvals`,
    {
      region_code: code,
    }
  );
  return response.data;
}

export async function pendingDopApprovals() {
  const response = await axios.get(
    `${membersUrlEndpoint}/pending_dop_approvals`
  );
  return response.data;
}

export async function dopApprovals(data) {
  const response = await axios.post(
    `${membersUrlEndpoint}/dop_approvals`,
    data
  );
  return response.data;
}

export async function dofApprovals(data) {
  const response = await axios.post(
    `${membersUrlEndpoint}/dof_approvals`,
    data
  );
  return response.data;
}

export async function getApproveMember(id) {
  const response = await axios.post(
    `${membersUrlEndpoint}/get_approved_member/${id}`
  );
  return response.data;
}

export async function findMemberByPfNumber(pf_number) {
  const response = await axios.post(
    `${membersUrlEndpoint}/find_member_by_pf_number`,
    { pf_number: pf_number }
  );
  return response.data;
}
export async function findMemberByMobileNumber(mobile_number) {
  const response = await axios.post(
    `${membersUrlEndpoint}/find_member_by_mobile_number`,
    {
      mobile_number: mobile_number,
    }
  );
  return response.data;
}
export async function findMemberByEmail(email) {
  const response = await axios.post(
    `${membersUrlEndpoint}/find_member_by_email`,
    { email: email }
  );
  return response.data;
}

export const getMemberByPagination = async (pageParam = 1) => {
  const response = await axios.get(
    `${membersUrlEndpoint}/${pageParam}?limit=20`
  );
  return response.data;
};

export async function findMember(data) {
  const response = await axios.post(`${membersUrlEndpoint}/find_member`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function uploadMemberProfilePictures(data) {
  const response = await axios.post(
    `${membersUrlEndpoint}/upload_profile_picture`,
    data,
    {
      withCredentials: true,
    }
  );
  return response.data;
}

// REGIONAL MEMBERS
export const regionalMembers = async (code) => {
  const response = await axios.post(REGIONAL_MEMBERS, { region_code: code });
  return response.data;
};
export async function activeRegionalMembers(code) {
  await delay();
  const response = await axios.post(ACTIVE_REGIONAL_MEMBERS, {
    region_code: code,
  });
  return response.data;
}

export async function inactiveRegionalMembers(code) {
  await delay();
  const response = await axios.post(INACTIVE_REGIONAL_MEMBERS, {
    region_code: code,
  });
  return response.data;
}

// REGIONS
const regionUrlEndpoint = "/regions";
const GET_REGION_NAME = "/regions/get_region_name";
const REGION_PRESIDENT = "/regions/regional_president";
const GET_REGION_BYCODE = "/regions/get_region_by_code";

export async function getRegions() {
  const response = await axios.get(`${regionUrlEndpoint}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function createRegion(data) {
  const response = await axios.post(`${regionUrlEndpoint}`, data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
    },
    withCredentials: true,
  });
  return response.data;
}

export async function updateRegion(data) {
  const response = await axios.patch(`${regionUrlEndpoint}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getRegionById(id) {
  const response = await axios.get(`${regionUrlEndpoint}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deleteRegion(id) {
  const response = await axios.delete(`${regionUrlEndpoint}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });

  return response.data;
}

export async function getRegionName(code) {
  const response = await axios.post(GET_REGION_NAME, { region_code: code });
  return response.data;
}

export async function getRegionPresident(code) {
  const response = await axios.post(REGION_PRESIDENT, { region_code: code });
  return response.data;
}

export async function getRegionByCode(code) {
  const response = await axios.post(GET_REGION_BYCODE, { region_code: code });
  return response.data;
}

export async function getRegionalMembersByCode(code) {
  const response = await axios.post(
    `${regionUrlEndpoint}/regional_members`,
    { code },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function getRegionalMembersByGender(data) {
  const response = await axios.post(
    `${regionUrlEndpoint}/regional_members_by_gender`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

const ALL_MAX_YEAR_LEDGERS = "/ledgers/get_max_year_ledgers";
const ALL_LEDGERS = "/ledgers/all_ledgers";
const GET_LEDGER_BY_ID = "/ledgers/get_ledger";
const GET_LEDGER_BY_PFNO = "/ledgers/get_ledger_by_pf";
const GET_LEDGER = "/ledgers/get_ledger";
const UPDATE_LEDGER = "/ledgers/update_ledger";
const DELETE_LEDGER = "/ledgers/delete_ledger";
const SAVE_LEDGER = "/ledgers/save_ledger";
const GET_LEDGER_CONTROL = "/ledgers/get_ledger_control";
const CHECK_LEDGER_CONTROL = "/ledgers/check_ledger_control";
const CREATE_YEAR_LEDGERS = "/ledgers/create_year_ledgers";
const GOOD_STANDING_MEMBERS = "/ledgers/members_in_goodstanding";
const MEMBERS_IN_ARREARS = "/ledgers/members_in_arrears";
const PART_PAYMENT_MEMBERS = "/ledgers/part_payment_members";

const SEARCH_LEDGER = "/ledgers/search_ledger";
const SEARCH_ARREARS = "/ledgers/search_arrears";
const SEARCH_GOODSTANDING = "/ledgers/search_goodstanding";
const SEARCH_PARTPAYMENT = "/ledgers/search_partpayment";

const REGIONAL_LEDGERS = "/ledgers/regional_ledgers";
const PAYMENT_LEDGER = "/ledgers/payment_ledger";
const PAYMENT_TRANSACTIONS_BYPF = "/ledgers/payment_transactions_bypf";
const PAYMENT_TRANSACTIONS_BYPHONE = "/ledgers/payment_transactions_byphone";
const LEDGER_BY_MOBILE_NUMBER = "/ledgers/get_ledger_by_mobile_number";

export async function getMaxYearLedgers() {
  const response = await axios.get(ALL_MAX_YEAR_LEDGERS);
  return response.data;
}
export async function getAllLedgers() {
  const response = await axios.get(ALL_LEDGERS);
  return response.data;
}
export async function getRegionalLedgers(code) {
  const response = await axios.post(REGIONAL_LEDGERS, { region_code: code });
  return response.data;
}
export async function getLedgerControl() {
  const response = await axios.get(GET_LEDGER_CONTROL);
  return response.data;
}
export async function getLedgerByID(id) {
  const response = await axios.get(GET_LEDGER_BY_ID + `/${id}`);
  return response.data;
}
export async function getLedgerByPfNumber(pf_number) {
  const response = await axios.post(GET_LEDGER_BY_PFNO, {
    pf_number: pf_number,
  });
  return response.data;
}

export async function saveLedger(data) {
  const response = await axios.post(SAVE_LEDGER, data);
  return response.data;
}
export async function getLedger(data) {
  const response = await axios.post(GET_LEDGER, data);
  return response.data;
}

export async function updateLedger(data) {
  const response = await axios.post(UPDATE_LEDGER, data);
  return response.data;
}
export async function deleteLedger(data) {
  const response = await axios.post(DELETE_LEDGER, data);
  return response.data;
}
export async function searchMemberLedger(data) {
  const response = await axios.post(SEARCH_LEDGER, data);
  return response.data;
}
export async function searchArrears(data) {
  const response = await axios.post(SEARCH_ARREARS, data);
  return response.data;
}
export async function searchGoodStanding(data) {
  const response = await axios.post(SEARCH_GOODSTANDING, data);
  return response.data;
}
export async function searchPartPayment(data) {
  const response = await axios.post(SEARCH_PARTPAYMENT, data);
  return response.data;
}
export async function checkLedgerControl(year) {
  const response = await axios.post(CHECK_LEDGER_CONTROL, { year: year });
  return response.data;
}
export async function createYearLedgers(data) {
  const response = await axios.post(CREATE_YEAR_LEDGERS, data);
  return response.data;
}

export const getGoodStandingMembers = async () => {
  await delay();
  const response = await axios.get(GOOD_STANDING_MEMBERS);
  return response.data;
};
export const getArrearsMembers = async () => {
  await delay();
  const response = await axios.get(MEMBERS_IN_ARREARS);
  return response.data;
};
export const getPartPaymentMembers = async () => {
  const response = await axios.get(PART_PAYMENT_MEMBERS);
  return response.data;
};

export async function getPaymentLedger(pf_number) {
  const response = await axios.post(PAYMENT_LEDGER, { pf_number: pf_number });
  return response.data;
}
export async function getLedgerMobile_number(mobile_number) {
  const response = await axios.post(LEDGER_BY_MOBILE_NUMBER, {
    mobile_number: mobile_number,
  });
  return response.data;
}
export async function paymentTransactionsByPf(pf_number) {
  const response = await axios.post(PAYMENT_TRANSACTIONS_BYPF, {
    pf_number: pf_number,
  });
  return response.data;
}
export async function paymentTransactionsByPhone(mobile_number) {
  const response = await axios.post(PAYMENT_TRANSACTIONS_BYPHONE, {
    mobile_number: mobile_number,
  });
  return response.data;
}

// DASHBOARD APIs
const VERIFY_USER = "/dashboard/verify_user";
const DASHBOARD_INFO = "/dashboard/get_dashboard_info";
const USER_DASHBOARD = "/dashboard/get_user_dashboard";
const MEMBERSHIP_SUMMARY = "/dashboard/membership_summary";

export async function verifyUser() {
  const response = await axios.get(VERIFY_USER);
  return response.data;
}

export async function getDashboardInfo() {
  await delay();
  const response = await axios.get(DASHBOARD_INFO);
  return response.data;
}
export async function getUserDashboard(region_code) {
  await delay();
  const response = await axios.post(USER_DASHBOARD, {
    region_code: region_code,
  });
  return response.data;
}
export async function membershipSummary() {
  await delay();
  const response = await axios.get(MEMBERSHIP_SUMMARY);
  return response.data;
}

const ALL_PRESIDENTS = "/presidents/get_presidents";
const GET_PRESIDENT_BYID = "/presidents/get_president";
const ADD_PRESIDENT = "/presidents/add_president";
const UPDATE_PRESIDENT = "/presidents/update_president";
const DELETE_PRESIDENT = "/presidents/delete_president";
const FIND_EMAIL = "/presidents/find_email";
const FIND_USER_BYEMAIL = "/presidents/find_user_email";

export async function getPresidents(res, req, next) {
  const response = await axios.get(ALL_PRESIDENTS);
  return response.data;
}

export async function getPresidentById(id) {
  const response = await axios.get(GET_PRESIDENT_BYID + `/${id}`);
  return response.data;
}

export async function addPresident(data) {
  const response = await axios.post(ADD_PRESIDENT, data);
  return response.data;
}
export async function updatePresident(data) {
  const response = await axios.patch(UPDATE_PRESIDENT + `/${data.id}`, data);
  return response.data;
}

export async function deletePresident(id) {
  const response = await axios.delete(DELETE_PRESIDENT + `/${id}`);
  return response.data;
}
export async function findPresidentByEmail(email) {
  const response = await axios.post(FIND_EMAIL, { email: email });
  return response.data;
}
export async function findUserByEmail(email) {
  const response = await axios.post(FIND_USER_BYEMAIL, { email: email });
  return response.data;
}

const CREATE_APPLICATION = "/applications/create_application";
const CREATE_OLD_MEMBERS = "/applications/create_old_members";
const AMEND_MEMBER_REGION = "/applications/amend_member_region";
const GET_ALL_APPLICATIONS = "/applications/all_applications";

const AWAITING_REGIONAL_APPROVALS = "/applications/awaiting_regional_approvals";
const REGIONAL_APPROVALS = "/applications/regional_approvals";
const REJECTED_APPLICATIONS = "/applications/rejected_applications";

const PENDING_DOP_APPROVALS = "/applications/pending_dop_approvals";
const GET_APPLICATION_BY_ID = "/applications/get_application";
const DOP_APPROVALS = "/applications/dop_approvals";

const PENDING_DOF_APPROVALS = "/applications/pending_dof_approvals";
const GET_APPROVED_APPLICATION = "/applications/get_approved_application";
const DOF_APPROVALS = "/applications/dof_approvals";

const UPDATE_APPLICATION = "/applications/update_application";
const DELETE_APPLICATION = "/applications/delete_record";
// const SEARCH_REGION = '/applications/search_by_region';
const SEARCH_CONSTITUENCY = "/applications/search_by_constituency";
const SEARCH_BRANCH = "/applications/search_by_branch";
const SEARCH_APPLICATION = "/applications/search_application";
const SEARCH_APPLICATION_PAYMENT = "/applications/search_application_payment";

const SEARCH_APPLICATION_ACCOUNT = "/applications/search_account";
// const FIND_PFNUMBER = "/api/applications/find_pf_number"

export async function createApplication(data) {
  console.log("application");
  const response = await axios.post(CREATE_APPLICATION, data);
  return response.data;
}
export async function createOldMembers(data) {
  await delay();
  const response = await axios.post(CREATE_OLD_MEMBERS, data);
  return response.data;
}
export async function amendMemberRegion(data) {
  await delay();
  const response = await axios.post(AMEND_MEMBER_REGION, data);
  return response.data;
}

export async function getAllApplications(email) {
  await delay();
  const response = await axios.post(GET_ALL_APPLICATIONS, email);
  return response.data;
}

export async function awaitingRegionalApprovals(email) {
  const response = await axios.post(AWAITING_REGIONAL_APPROVALS, {
    regional_email: email,
  });
  return response.data;
}
export async function regionalApprovals(email) {
  const response = await axios.post(REGIONAL_APPROVALS, email);
  return response.data;
}
export async function getRejectedApplications() {
  const response = await axios.get(REJECTED_APPLICATIONS);
  return response.data;
}

export async function pendingDofApprovals() {
  const response = await axios.get(PENDING_DOF_APPROVALS);
  return response.data;
}

export async function getApprovedApplication(id) {
  const response = await axios.post(GET_APPROVED_APPLICATION, { id: id });
  return response.data;
}

export async function getApplicationById(id) {
  const response = await axios.get(GET_APPLICATION_BY_ID + `/${id}`);
  return response.data;
}

export async function updateApplication(data) {
  const response = await axios.post(UPDATE_APPLICATION, data);
  return response.data;
}

export async function deleteApplication(id) {
  const response = await axios.post(DELETE_APPLICATION, { id: id });
  return response.data;
}

export async function searchByRegion(data) {
  const response = await axios.post(SEARCH_REGION, { region_code: data });
  return response.data;
}
export async function searchByConstituency(data) {
  const response = await axios.post(SEARCH_CONSTITUENCY, {
    constituency_code: data,
  });
  return response.data;
}
export async function searchByBranch(data) {
  const response = await axios.post(SEARCH_BRANCH, { branch_code: data });
  return response.data;
}
export async function searchApplication(data) {
  const response = await axios.post(SEARCH_APPLICATION, data);
  return response.data;
}
export async function searchApplicationPayment(data) {
  const response = await axios.post(SEARCH_APPLICATION_PAYMENT, data);
  return response.data;
}
export async function searchApplicationAccount(data) {
  const response = await axios.post(SEARCH_APPLICATION_ACCOUNT, data);
  return response.data;
}

export async function findPfNumber(pf_number) {
  const response = await axios.post(FIND_PFNUMBER, { pf_number: pf_number });
  return response.data;
}

const ALL_REGIONAL_REPORTS = "/reports/all_regional_reports";
const ADD_REGIONAL_REPORT = "/reports/add_regional_report";
const GET_REGIONAL_REPORT_BY_ID = "/reports/get_regional_report";
const UPDATE_REGIONAL_REPORT = "/reports/update_regional_report";
const DELETE_REGIONAL_REPORT = "/reports/delete_record";
const FILTER_REPORT = "/reports/filter_report";

export async function getAllRegionalReports() {
  const response = await axios.get(ALL_REGIONAL_REPORTS);
  return response.data;
}

export async function addRegionalReport(data) {
  const response = await axios.post(ADD_REGIONAL_REPORT, data);
  return response.data;
}

export async function getRegionalReportById(id) {
  const response = await axios.get(GET_REGIONAL_REPORT_BY_ID + `/${id}`);
  return response.data;
}

export async function updateRegionalReport({ id, data }) {
  const response = await axios.post(UPDATE_REGIONAL_REPORT + `/${id}`, data);
  return response.data;
}

export async function deleteRegionalReport(id) {
  const response = await axios.post(DELETE_REGIONAL_REPORT + `/${id}`);
  return response.data;
}
export async function filterReport(data) {
  const response = await axios.post(FILTER_REPORT, data);
  return response.data;
}

const ALL_MESSAGES = "/messages/all_messages";
const GET_MESSAGE = "/messages/get_message";
const ADD_MESSAGE = "/messages/add_message";
const UPDATE_MESSAGE = "/messages/update_message";
const DELETE_MESSAGE = "/messages/delete_record";

export async function getAllMessages() {
  const response = await axios.get(ALL_MESSAGES);
  return response.data;
}

export async function getMessageById(id) {
  const response = await axios.get(GET_MESSAGE + `/${id}`);
  return response.data;
}

export async function addMessage(data) {
  const response = await axios.post(ADD_MESSAGE, data);
  return response.data;
}

export async function updateMessage(data) {
  const response = await axios.post(UPDATE_MESSAGE, data);
  return response.data;
}

export async function deleteMessage(id) {
  const response = await axios.post(DELETE_MESSAGE, { id: id });
  return response.data;
}

const CARDS = "/cards/all_cards";
const GET_CARD_BYID = "/cards/get_card";
const ADD_CARD = "/cards/add_card";
const UPDATE_CARD = "/cards/update_card";
const DELETE_CARD = "/cards/delete_record";

const PAGINATING_CARDS = "/cards/paginating_cards";
const PAGINATED_CARDS = "/cards/paginated_cards";
const CARDSPAGE = "/cards/all_cards?page=";
const FETCH_CARDS = "/cards/fetch_cards?page=";
const SENT_TO_PRINTER = "/cards/sent_to_printer";
const PENDING_CARDS = "/cards/pending_cards";

const SEARCH_CARD = "/cards/search_card";
const SEND_TO_PRINTER = "/cards/send_to_printer";
const UPDATE_SENT_TO_PRINTER = "/cards/update_send_to_printer";

export async function getCards() {
  const response = await axios.get(CARDS);
  return response.data;
}
export async function getCardById(id) {
  const response = await axios.get(GET_CARD_BYID + `/${id}`);
  return response.data;
}

export async function searchCard(data) {
  const response = await axios.post(SEARCH_CARD, data);
  return response.data;
}

export async function addCard(data) {
  const response = await axios.post(ADD_CARD, data);
  return response.data;
}

export async function updateCard(data) {
  const response = await axios.post(UPDATE_CARD, data);
  return response.data;
}

export async function deleteCard(id) {
  const response = await axios.post(DELETE_CARD, { id: id });
  return response.data;
}

export const paginatedCards = async (page) => {
  const response = await axios.get(
    `${PAGINATED_CARDS}/?page=${page}&pageSize=20`
  );
  return response.data;
};

export const paginatingCards = async (page) => {
  const postsPerPage = 20;
  const response = await axios.get(
    `${PAGINATING_CARDS}?page=${page}&limit=${postsPerPage}`
  );
  return response.data;
};

export const getCardsPage = async (pageParam = 1) => {
  const response = await axios.get(CARDSPAGE + `${pageParam}?limit=20`);
  return response.data;
};

export async function fetchCards(page = 1) {
  const response = await axios.get(CARDSPAGE + `${page}`);
  return response.data;
}

export async function toPrinter() {
  const response = await axios.get(SENT_TO_PRINTER);
  return response.data;
}
export async function pendingCards() {
  const response = await axios.get(PENDING_CARDS);
  return response.data;
}

export async function sendToPrinter() {
  const response = await axios.get(SEND_TO_PRINTER);
  return response.data;
}
export async function updateSentToPrinter() {
  const response = await axios.post(UPDATE_SENT_TO_PRINTER);
  return response.data;
}
export const getCardsPage1 = async (pageParam = 1, options = {}) => {
  const response = await axios.get(FETCH_CARDS + `${pageParam}`, options);
  return response.data;
};

const YEARLY_PAYMENTS = "/yearly_payments/get_yearly_payments";
const GET_YEARLY_PAYMENT_BYID = "/yearly_payments/get_yearly_payment";
const ADD_YEARLY_PAYMENT = "/yearly_payments/add_yearly_payment";
const UPDATE_YEARLY_PAYMENT = "/yearly_payments/update_yearly_payment";
const DELETE_YEARLY_PAYMENT = "/yearly_payments/delete_yearly_payment";
const GET_PREVIOUS_YEAR_PAYMENT = "/yearly_payments/get_previous_year_payment";

export async function getYearlyPayments() {
  const response = await axios.get(YEARLY_PAYMENTS);
  return response.data;
}

export async function getYearlyPaymentById(id) {
  const response = await axios.get(GET_YEARLY_PAYMENT_BYID + `/${id}`);
  return response.data;
}

export async function addYearlyPayment(data) {
  const response = await axios.post(ADD_YEARLY_PAYMENT, data);
  return response.data;
}

export async function updateYearlyPayment(data) {
  const response = await axios.patch(
    UPDATE_YEARLY_PAYMENT + `/${data.id}`,
    data
  );
  return response.data;
}

export async function deleteYearlyPayment(id) {
  const response = await axios.delete(DELETE_YEARLY_PAYMENT + `/${id}`);
  return response.data;
}
export async function getPreviousYearPayment(year) {
  const response = await axios.post(GET_PREVIOUS_YEAR_PAYMENT, {
    year: year,
  });
  return response.data;
}

const PAYMENT_TYPES = "/yearly_payments/get_payment_types";
const GET_PAYMENT_TYPE_BYID = "/yearly_payments/get_payment_type";
const ADD_PAYMENT_TYPE = "/yearly_payments/add_payment_type";
const UPDATE_PAYMENT_TYPE = "/yearly_payments/update_payment_type";
const DELETE_PAYMENT_TYPE = "/yearly_payments/delete_payment_type";
const GET_PAYMENT_TYPE_BYCODE = "/yearly_payments/get_payment_type";

export async function getPaymentTypes() {
  const response = await axios.get(PAYMENT_TYPES);
  return response.data;
}

export async function getPaymentTypeById(id) {
  const response = await axios.get(GET_PAYMENT_TYPE_BYID + `/${id}`);
  return response.data;
}

export async function addPaymentType(data) {
  const response = await axios.post(ADD_PAYMENT_TYPE, data);
  return response.data;
}

export const updatePaymentType = async (data) => {
  const response = await axios.patch(UPDATE_PAYMENT_TYPE + `/${data.id}`, data);
  return response.data;
};

export async function deletePaymentType(id) {
  const response = await axios.delete(DELETE_PAYMENT_TYPE + `/${id}`);
  return response.data;
}

export async function getPaymentTypeByCode(code) {
  const response = await axios.post(GET_PAYMENT_TYPE_BYCODE, {
    type_code: code,
  });
  return response.data;
}

// const TYPES = '/payments/all_types';
const GET_TYPE = "/payments/get_type";
const ADD_TYPE = "/payments/add_type";
const UPDATE_TYPE = "/payments/update_type";
const DELETE_TYPE = "/payments/delete_record";
const GET_TYPE_NAME = "/payments/get_type_name";
const GET_TYPE_AMOUNT = "/payments/get_type_amount";

const GET_ALL_PAYMENTS = "/payments/get_all_payments";
const GET_PAYMENT_BYID = "/payments/get_payment";
const SAVE_PAYMENT = "/payments/save_payment";
const GET_PAYMENT_BYPF = "/payments/get_payment";
const GET_PAYMENTS_BY_DATE = "/payments/by_date";
const GET_PAYMENTS_BY_PERIOD = "/payments/by_period";
const FIND_PAYMENTS = "/payments/find_payments";
const GET_PAYMENTS_BY_MODE = "/payments/get_payments_by_mode";
const UPDATE_ACCOUNT = "/payments/update_account";
const DETAILED_STATEMENT = "/payments/detailed_statement";
const SUMMARY_STATEMENT = "/payments/summary_statement";
const GENERATE_PDF = "/payments/generate_pdf";

const GET_TYPES = "/payments/get_paytypes";
const GET_TYPECODE = "/payments/get_typecode";
const ADD_TYPES = "/payments/add_paytypes";
const UPDATE_TYPES = "/payments/update_paytypes";

const GENERATE_DETAILED_STATEMENT = "/payments/generate_detailed_statement";
const GENERATE_SUMMARY_STATEMENT = "/payments/generate_summary_statement";
const SEARCH_PAYMENT = "/payments/search_payment";
const REGIONAL_PAYMENT_TRANSACTIONS = "/payments/regional_payment_transactions";
const MANDATORY_PAYMENTS = "/payments/mandatory_payments";
const TWOMTWO_PAYMENTS = "/payments/twomtwo_payments";

export async function mandatoryPayments() {
  const response = await axios.get(MANDATORY_PAYMENTS);
  return response.data;
}

export async function twoMTwoPayments() {
  const response = await axios.get(TWOMTWO_PAYMENTS);
  return response.data;
}

export async function getType(id) {
  const response = await axios.get(GET_TYPE + `/${id}`);
  return response.data;
}
export function saveType(id, data) {
  return id ? updateType(data) : createType(data);
}

export async function createType(data) {
  const response = await axios.post(ADD_TYPE, data);
  return response.data;
}

async function updateType(data) {
  const response = await axios.post(UPDATE_TYPE, data);
  return response.data;
}

export async function deleteType(id) {
  const response = await axios.post(DELETE_TYPE, { id: id });
  return response.data;
}
export async function getTypeName(code) {
  const response = await axios.post(GET_TYPE_NAME, { type_code: code });
  return response.data;
}
export async function getTypeAmount(code) {
  const response = await axios.post(GET_TYPE_AMOUNT, { payment_code: code });
  return response.data;
}

// PAYMENT SECTION
export async function getAllPayments() {
  const response = await axios.get(GET_ALL_PAYMENTS);
  return response.data;
}
export async function getPaymentById(id) {
  const response = await axios.get(GET_PAYMENT_BYID + `/${id}`);
  return response.data;
}
export async function savePayment(data) {
  const response = await axios.post(SAVE_PAYMENT, data);
  return response.data;
}
export async function getPaymentsByDates(data) {
  const response = await axios.post(GET_PAYMENTS_BY_DATE, data);
  return response.data;
}
export async function getPaymentsByPeriod(data) {
  const response = await axios.post(GET_PAYMENTS_BY_PERIOD, data);
  return response.data;
}
export async function getRegionalPayments(code) {
  const response = await axios.post(REGIONAL_PAYMENT_TRANSACTIONS, {
    region_code: code,
  });
  return response.data;
}
export async function getPaymentsByMode(data) {
  const response = await axios.post(GET_PAYMENTS_BY_MODE, data);
  return response.data;
}
export async function getPaymentByPf(pf_number) {
  const response = await axios.post(GET_PAYMENT_BYPF, {
    pf_number: pf_number,
  });
  return response.data;
}

export async function findPaymentByReceiptNo(receipt) {
  const response = await axios.post(`${FIND_PAYMENTS}/${receipt}`);
  return response.data;
}
export async function updateAccount(data) {
  const response = await axios.post(UPDATE_ACCOUNT, data);
  return response.data;
}

export async function detailedStatement(data) {
  const response = await axios.post(DETAILED_STATEMENT, data);
  return response.data;
}
export async function summaryStatement(data) {
  const response = await axios.post(SUMMARY_STATEMENT, data);
  return response.data;
}
export async function generatePDF(data) {
  const response = await axios.post(GENERATE_PDF, data);
  return response.data;
}

export async function getPayTypes() {
  const response = await axios.get(GET_TYPES);
  return response.data;
}
export async function getPayTypeCode(code) {
  const response = await axios.post(GET_TYPECODE, { description: code });
  return response.data;
}
export function savePayTypes(id, data) {
  return id ? updatePayTypes(data) : createPayTypes(data);
}

export async function createPayTypes(data) {
  const response = await axios.post(ADD_TYPES, data);
  return response.data;
}

async function updatePayTypes(data) {
  const response = await axios.post(UPDATE_TYPES, data);
  return response.data;
}

export async function generateDetailedStatement(data) {
  const response = await axios.post(GENERATE_DETAILED_STATEMENT, data);
  return response.data;
}
export async function generateSummaryStatement(data) {
  const response = await axios.post(GENERATE_SUMMARY_STATEMENT, data);
  return response.data;
}

// Card/Momo/Cheque Payment
const GET_PAYMENT_CLEARANCE = "/payments/get_payment_clearance";
const ADD_CARD_PAYMENT = "/payments/add_card_payment";
const ADD_MOMO_PAYMENT = "/payments/add_momo_payment";
const ADD_DONATION_PAYMENT = "/payments/add_donation_payment";
const ADD_CHEQUE_PAYMENT = "/payments/add_cheque_payment";
const SAVE_ONLINE_PAYMENT = "/payments/save_online_payment";
const UPDATE_PAYMENT_CLEARANCE = "/payments/update_payment_clearance";
const DELETE_PAYMENT_CLEARANCE = "/payments/delete_payment_clearance";
const GENERATE_NEW_APPLICANT_MOMO_PAYMENT =
  "/payments/generate_new_applicant_momo_payment";
const GENERATE_EXISTING_MEMBER_MOMO_PAYMENT =
  "/payments/generate_existing_member_momo_payment";

export async function getPaymentClearance() {
  const response = await axios.get(GET_PAYMENT_CLEARANCE);
  return response.data;
}
export async function getPaymentClearanceById(id) {
  const response = await axios.get(GET_PAYMENT_CLEARANCE + `/${id}`);
  return response.data;
}

export async function addCardPayment(data) {
  await delay();
  const response = await axios.post(ADD_CARD_PAYMENT, data);
  return response.data;
}

export async function generateNewApplicantMoMoPayment(data) {
  const response = await axios.post(GENERATE_NEW_APPLICANT_MOMO_PAYMENT, data);
  return response.data;
}
export async function generateExistingMemberMoMoPayment(data) {
  const response = await axios.post(
    GENERATE_EXISTING_MEMBER_MOMO_PAYMENT,
    data
  );
  return response.data;
}

export async function addMomoPayment(data) {
  // await delay()
  const response = await axios.post(ADD_MOMO_PAYMENT, data);
  return response.data;
}
export async function addDonationPayment(data) {
  await delay();
  const response = await axios.post(ADD_DONATION_PAYMENT, data);
  return response.data;
}
export async function addChequePayment(data) {
  await delay();
  const response = await axios.post(ADD_CHEQUE_PAYMENT, data);
  return response.data;
}
export async function saveOnlinePayment(data) {
  const response = await axios.post(SAVE_ONLINE_PAYMENT, data);
  return response.data;
}
export async function updatePaymentClearance(id) {
  return await axios.patch(UPDATE_PAYMENT_CLEARANCE + `/${id}`);
}
export async function deletePaymentClearance(id) {
  return await axios.delete(DELETE_PAYMENT_CLEARANCE + `/${id}`);
}

export async function searchPayment(data) {
  const response = await axios.post(SEARCH_PAYMENT, data);
  return response.data;
}

const BRANCHES = "/branches/all_branches";
const GET_BRANCH = "/branches/get_branch";
const ADD_BRANCH = "/branches/add_branch";
const UPDATE_BRANCH = "/branches/update_branch";
const DELETE_BRANCH = "/branches/delete_record";
const CONSTITUENCY_BRANCH = "/branches/constituency_branches";
const BRANCH_NAME = "/branches/get_branch_name";

export async function getBranches() {
  const response = await axios.get(BRANCHES);
  return response.data;
}

export async function getBranch(id) {
  const response = await axios.get(GET_BRANCH + `/${id}`);
  return response.data;
}

export function saveBranch(id, data) {
  return id ? updateBranch(data) : createBranch(data);
}

export async function createBranch(data) {
  const response = await axios.post(ADD_BRANCH, data);
  return response.data;
}

async function updateBranch(data) {
  const response = await axios.post(UPDATE_BRANCH, data);
  return response.data;
}

export async function deleteBranch(id) {
  const response = await axios.post(DELETE_BRANCH, { id: id });
  return response.data;
}
export async function getConstBranches(code) {
  const response = await axios.post(CONSTITUENCY_BRANCH, {
    constituency_code: code,
  });
  return response.data;
}

export async function getBranchName(code) {
  const response = await axios.post(BRANCH_NAME, { branch_code: code });
  return response.data;
}

const CONSTITUENCIES = "/constituencies/all_constituencies";
const GET_CONSTITUENCY = "/constituencies/get_constituency";
const GET_REGIONCONSTI = "/constituencies/region_constituencies";
const ADD_CONSTITUENCY = "/constituencies/add_constituency";
const UPDATE_CONSTITUENCY = "/constituencies/update_constituency";
const DELETE_CONSTITUENCY = "/constituencies/delete_record";
const GET_CONSTITUENCY_NAME = "/constituencies/get_constituency_name";

export async function getConstituencies() {
  const response = await axios.get(CONSTITUENCIES);
  return response.data;
}

export async function getConstituency(id) {
  const response = await axios.get(GET_CONSTITUENCY + `/${id}`);
  return response.data;
}
export async function getRegionConst(code) {
  const response = await axios.post(GET_REGIONCONSTI, { region_code: code });
  return response.data;
}

export function saveConstituency(id, data) {
  return id ? updateConstituency(data) : createConstituency(data);
}

export async function createConstituency(data) {
  const response = await axios.post(ADD_CONSTITUENCY, data);
  return response.data;
}

async function updateConstituency(data) {
  const response = await axios.post(UPDATE_CONSTITUENCY, data);
  return response.data;
}

export async function deleteConstituency(id) {
  const response = await axios.post(DELETE_CONSTITUENCY, { id: id });
  return response.data;
}

export async function getConstName(code) {
  const response = await axios.post(GET_CONSTITUENCY_NAME, {
    constituency_code: code,
  });
  return response.data;
}

const ACCESSTOKEN = "/private_pay/get_accesstoken";
const ACCOUNT_INFO = "/private_pay/account_info";
const COLLECTION_SERVICE_LIST = "/private_pay/collection_service";
const PAYOUT_SERVICE_LIST = "/private_pay/collection_service";
const PAYOUT = "/private_pay/payout";
const COLLECTION = "/private_pay/collection";
const COLLECTION_CARD = "/private_pay/collection_card";

// GET GetAccessToken
export async function accessToken() {
  return await axios.get(ACCESSTOKEN);
}

// POST GetAccountInfo
export async function getAccountInfo(data) {
  return await axios.post(ACCOUNT_INFO, data);
}

// POST Collection Service List
export async function collectionService(data) {
  return await axios.post(COLLECTION_SERVICE_LIST, data);
}
// POST Payout Service List
export async function payoutService(data) {
  return await axios.post(PAYOUT_SERVICE_LIST, data);
}

// POST Payout
export async function payOut(data) {
  return await axios.post(PAYOUT, data);
}

//POST Colleection
export async function collection(data) {
  return await axios.post(COLLECTION, data);
}

//POST Collection Card
export async function collectionCard(data) {
  return await axios.post(COLLECTION_CARD, data);
}

//POST Check Status
export async function checkStatus() {}

// CallBack
export async function callBack() {}

// BANKS API
const BANKS = "/banks/get_banks";

const SEARCH_BANK = "/banks/search_bank";

const ALL_BANKS = "/banks/get_banks";
const GET_BANK_BYID = "/banks/get_bank";
const ADD_BANK = "/banks/add_bank";
const UPDATE_BANK = "/banks/update_bank";
const DELETE_BANK = "/banks/delete_bank";
const GET_BANK_BY_SORTCODE = "/banks/get_bank_by_sortcode";

export async function getAllBanks() {
  const response = await axios.get(ALL_BANKS);
  return response.data;
}

export async function getBankBySortcode(code) {
  const response = await axios.post(GET_BANK_BY_SORTCODE, {
    bank_sortcode: code,
  });
  return response.data;
}

export async function getBanks() {
  await delay();
  const response = await axios.get(BANKS, {
    withCredentials: true,
  });
  return response.data;
}

export async function addBank(data) {
  const response = await axios.post(ADD_BANK, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function updateBank(data) {
  const response = await axios.patch(`${UPDATE_BANK}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getBankById(id) {
  // await delay()
  const response = await axios.get(`${GET_BANK_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function deleteBank(id) {
  const response = await axios.delete(`${DELETE_BANK}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function searchBank(data) {
  const response = await axios.post(
    SEARCH_BANK,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    },
    { data: data }
  );
  return response.data;
}
// BANK BRANCHES API
const BANK_BRANCHES = "/banks/get_branches";
const ADD_BANK_BRANCH = "/banks/add_branch";
const GET_BANK_BRANCH_BYID = "/banks/get_branch";
const GET_BANK_BRANCH_BY_SORTCODE = "/banks/get_branch_by_sortcode";
const UPDATE_BANK_BRANCH = "/banks/update_branch";
// const DELETE_BANK_BRANCH = '/banks/delete_branch';

export async function getBankBranches() {
  const response = await axios.get(BANK_BRANCHES);
  return response.data;
}

export async function addBankBranch(data) {
  const response = await axios.post(ADD_BANK_BRANCH, data);
  return response.data;
}

export async function getBankBranchById(id) {
  const response = await axios.get(`${GET_BANK_BRANCH_BYID}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getBankBranchBySortcode(code) {
  const response = await axios.post(GET_BANK_BRANCH_BY_SORTCODE, {
    branch_sortcode: code,
  });
  return response.data;
}

export async function updateBankBranch({ id, data }) {
  const response = await axios.patch(`${UPDATE_BANK_BRANCH}/${id}`, data);
  return response.data;
}

export async function deleteBankBranch(id) {
  const response = await axios.post(`${DELETE_BANK}/${id}`);
  return response.data;
}

// DASHBOARD APIs
const DASHBOARD = "/member_dashboard/verify_member";
const PAYMENT_TRANSACTIONS = "/member_dashboard/get_payment_transactions";
const EXPECTED_PAYMENT = "/member_dashboard/expected_total_payments";
const SUM_PAYMENTS = "/member_dashboard/sum_total_payments";
const LEDGER_BALANCE = "/member_dashboard/get_ledger_balance";
const DASHBOARD_SUMMARY = "/member_dashboard/get_summary";
const GET_PAYMENT_BY_RECEIPT = "/member_dashboard/get_payments";

export async function memberDashboard() {
  const response = await axios.get(DASHBOARD);
  return response.data;
}

export async function getPaymentTransactions() {
  const response = await axios.get(PAYMENT_TRANSACTIONS);
  return response.data;
}

export async function expectedTotalPayments() {
  const response = await axios.get(EXPECTED_PAYMENT);
  return response.data;
}

export async function sumTotalPayments() {
  const response = await axios.get(SUM_PAYMENTS);
  return response.data;
}
export async function getLedgerBalance() {
  const response = await axios.get(LEDGER_BALANCE);
  return response.data;
}

// Member Dashboard Summary
export async function getDashboardSummary(pf_number) {
  const response = await axios.post(DASHBOARD_SUMMARY, {
    pf_number: pf_number,
  });
  return response.data;
}
export async function getPaymentByReceiptNo(id) {
  const response = await axios.post(`${GET_PAYMENT_BY_RECEIPT}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

// ONLINE PAYMENT
const onlinePaymentURLEndpoint = "/online_payments";

// GET GetAccessToken
export async function onlineAccessToken() {
  return await axios.get(`${onlinePaymentURLEndpoint}/accesstoken`);
}
// GET GetAccessToken
export async function getOnlineAccessToken() {
  return await axios.get(`${onlinePaymentURLEndpoint}/get_accesstoken`);
}

// POST GetAccountInfo
export async function onlineAccountInfo(data) {
  return await axios.post(`${onlinePaymentURLEndpoint}/accountinfo`, data);
}

// POST Collection Service List
export async function onlineCollectionService(data) {
  return await axios.post(
    `${onlinePaymentURLEndpoint}/collectionservices`,
    data
  );
}
// POST Payout Service List
export async function onlinePayoutService(data) {
  return await axios.post(`${onlinePaymentURLEndpoint}/payoutservices`, data);
}

// POST Payout
export async function onlinePayout(data) {
  return await axios.post(`${onlinePaymentURLEndpoint}/payout`, data);
}

//POST Collection
export async function onlineCollection(data) {
  return await axios.post(`${onlinePaymentURLEndpoint}/collection`, data);
}

//POST Collection Card
export async function onlineCollectionCard(data) {
  return await axios.post(`${onlinePaymentURLEndpoint}/collectioncard`, data);
}
//POST Collection Card
export async function onlineCheckStatus(data) {
  return await axios.post(`${onlinePaymentURLEndpoint}/transstatus`, data);
}

// CallBack
export async function onlineCallBack(data) {
  return await axios.post(`${onlinePaymentURLEndpoint}/callback`, data);
}

// EXPENDITURE

const expenditureUrlEndpoint = "/expenditure";

export async function getExpenditures() {
  const response = await axios.get(`${expenditureUrlEndpoint}`);
  return response.data;
}

export async function addExpenditure(data) {
  return await axios.post(`${expenditureUrlEndpoint}`, data);
}

export async function updateExpenditure(data) {
  return await axios.patch(`${expenditureUrlEndpoint}/${data.id}`, data);
}

export async function deleteExpenditure(id) {
  return await axios.delete(`${expenditureUrlEndpoint}/${id}`, { id: id });
}

export async function getExpenditureById(id) {
  return await axios.get(`${expenditureUrlEndpoint}/${id}`);
}

// REVENUE
const revenueUrlEndpoint = "/revenue";

export async function getRevenues() {
  const response = await axios.get(`${revenueUrlEndpoint}`);
  return response.data;
}

export async function addRevenue(data) {
  return await axios.post(`${revenueUrlEndpoint}`, data);
}

export async function updateRevenue(data) {
  return await axios.patch(`${revenueUrlEndpoint}/${data.id}`, data);
}

export async function deleteRevenue(id) {
  return await axios.delete(`${revenueUrlEndpoint}/${id}`, { id: id });
}

export async function getRevenueById(id) {
  return await axios.get(`${revenueUrlEndpoint}/${id}`);
}

// POLLING AGENTS
const agentsUrlEndpoint = "/agents";

export async function getAllAgents() {
  const response = await axios.get(`${agentsUrlEndpoint}`);
  return response.data;
}

export async function getAgentById(id) {
  const response = await axios.get(`${agentsUrlEndpoint}/${id}`, {
    withCredentials: true,
  });
  return response.data;

  // const = await axios.get(`${agentsUrlEndpoint}/${id}`,
  //     {
  //         headers: { 'Content-Type': 'application/json' },
  //         withCredentials: true
  //     }
  // );
  // return response.data;
}

export async function addAgent(data) {
  const response = await axios.post(
    `${agentsUrlEndpoint}`,
    { data },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function updateAgent(data) {
  const response = await axios.patch(`${agentsUrlEndpoint}/${data.id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deleteAgent(id) {
  const response = await axios.delete(
    `${agentsUrlEndpoint}/${id}`,
    { id: id },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

// ACTIVATION & DEACTIVATION
const memberManagementUrl = "/members";
const userManagementUrl = "/users";
export async function memberActivation(data) {
  const response = await axios.post(
    `${memberManagementUrl}/activate_member`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function memberDeactivation(data) {
  const response = await axios.post(
    `${memberManagementUrl}/deactivate_member`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function userActivation(data) {
  const response = await axios.post(
    `${userManagementUrl}/activate_user`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function userDeactivation(data) {
  const response = await axios.post(
    `${userManagementUrl}/deactivate_user`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

const cvUrlEndpoint = "/cvs";

export async function getAllCVs() {
  await delay();
  const response = await axios.get(`${cvUrlEndpoint}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function uploadCV(data) {
  const response = await axios.post(`${cvUrlEndpoint}/upload_cv`, data);
  return response.data;
}
export async function getMyCV(data) {
  const response = await axios.post(
    `${cvUrlEndpoint}/find_cv`,
    { pf_number: data },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function replaceCV(data) {
  const response = await axios.post(`${cvUrlEndpoint}/replace_cv`, data);
  return response.data;
}

// ELECTIONS & VOTING
// CONTESTANTS  API
const contestantsUrlEndpoint = "/contestants";

export async function getContestants() {
  const response = await axios.get(contestantsUrlEndpoint, {
    withCredentials: true,
  });
  return response.data;
}

export async function registerContestant(data) {
  const response = await axios.post(contestantsUrlEndpoint, data, {
    withCredentials: true,
  });
  return response.data;
}

export async function updateContestant(data) {
  const response = await axios.patch(
    `${contestantsUrlEndpoint}/${data.id}`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}
export async function getContestantById(id) {
  const response = await axios.get(`${contestantsUrlEndpoint}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function deleteContestant(id) {
  const response = await axios.delete(`${contestantsUrlEndpoint}/${id}`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });

  return response.data;
}

export async function verifyContestant(data) {
  const response = await axios.post(
    `${contestantsUrlEndpoint}/verify_user`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
}

// VOTE API
const voteUrlEndpoint = "/votes";

export async function getVoteCast() {
  const response = await axios.get(`${voteUrlEndpoint}/vote_cast`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}
export async function getFinalVoteCast() {
  const response = await axios.get(`${voteUrlEndpoint}/final_vote_cast`, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function castVote(data) {
  const response = await axios.post(`${voteUrlEndpoint}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
  return response.data;
}

export async function memberStatistics() {
  const response = await axios.get(`${membersUrlEndpoint}/details`, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
  return response.data;
}

// AGANOW APIs

const aganowAPIURLEndpoint = "/eganow";

// Get AccessToken
export async function checkToken() {
  return await axios.get(`${aganowAPIURLEndpoint}/api`);
}
export async function getAccessToken() {
  return await axios.get(`${aganowAPIURLEndpoint}/auth/token`);
}
// Verify AccessToken
export async function verifyAccessToken() {
  return await axios.get(`${aganowAPIURLEndpoint}/auth/verify`);
}

// Service Partner Search
export async function searchPartner(data) {
  return await axios.post(`${aganowAPIURLEndpoint}/partners/search`, data);
}

// Service Partner Charges
export async function partnerCharges(data) {
  return await axios.post(`${aganowAPIURLEndpoint}/partners/charges`, data);
}

// POST VAS KYC
export async function payerInformation(data) {
  return await axios.post(`${aganowAPIURLEndpoint}/payer_information`, data);
}

// Transaction Collection
export async function transactionsCollection(data) {
  return await axios.post(
    `${aganowAPIURLEndpoint}/transactions_collection`,
    data
  );
}
// Transactions Status
export async function transactionsStatus(data) {
  return await axios.post(`${aganowAPIURLEndpoint}/transactions/status`, data);
}
// Transactions Balances
export async function transactionsBalances(data) {
  return await axios.get(`${aganowAPIURLEndpoint}/transactions/balances`, data);
}
